<section
  [attr.data-cy]="'aiomed-half-screen-modal'"
  [style.--modal-width]="width()"
  [style.--zindex]="zIndex()"
  class="half-screen-modal">
  <div class="half-screen-modal__container">
    <h3 class="half-screen-modal__title">
      {{ title() }}
    </h3>
    <div
      class="half-screen-modal__description"
      [style.--description-width]="descriptionWidth()">
      <ng-container
        [ngTemplateOutlet]="
          descriptionTemplate() || defaultTemplate
        "></ng-container>
      <ng-template #defaultTemplate>
        {{ description() }}
      </ng-template>
    </div>
    <div class="half-screen-modal__image">
      <img [src]="imageSource()" [alt]="imageSource()" />
    </div>
    <div class="half-screen-modal__actions">
      <button
        class="half-screen-modal__close"
        [style.--button-width]="buttonWidth()"
        [attr.data-cy]="'half-screen-modal__close'"
        (click)="close.emit()">
        <span>
          {{ buttonText() }}
        </span>
        <span nz-icon nzType="aio:lightning-regular"></span>
      </button>
    </div>
  </div>
</section>
